import styled from "styled-components";

const Button = styled.button`
  padding: 2%;
  align-content: center;
  margin: 0 10px;
  border: none;
  cursor: pointer;
  background-color: lightskyblue;
`;

export default Button;
